// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CPVTx","left":"styles_left__2jzNZ","desktopActions":"styles_desktopActions__14m-s","title":"styles_title__1Aorj"};